import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import axios from 'axios';
import WindowAlert from '../common/AlertComponent';
import '~/stylesheets/login.page.scss';
import img from '~/assets/Logo_big.png';
import { kinetik_api_url } from '../utilities/const';
class ForgotPassword extends Component {
    constructor(props){
        super(props);
        this.state= {
            messageType: '',
            message: '',
            isRequestSent: false,
            // isRedirect: false
        }

        //bg_color_fix
        if (window.location.pathname === "/forgotPassword") {
            document.body.className = "fix_bg";
        }
    }

    handleAlert = () => {
        this.setState({isRequestSent: this.state.isRequestSent ? false : true})
    }

    forgetPwHandler = () => {
        let email =  document.getElementById('email').value;

        if(email !== '') {

            let URL = kinetik_api_url + '/forget_password';

            axios.put(URL, {email})
            .then( (result) => {
                this.setState({
                    messageType: result.data.status,
                    message: result.data.message,
                    isRequestSent: true,
                    isRedirect: true
                })
            })
            .catch( (err) => {
                this.setState({
                    message: 'No user found',
                    messageType: 'error',
                    isRequestSent: true
                });
            })
        } else {
            this.setState({
                message: 'Please enter a valid email address',
                messageType: 'error',
                isRequestSent: true
            })
        }
    }
    render () {

        // if(this.state.isRedirect) {
        //     return <Redirect to="/login" />
        // }
        return (
            <div className="container-fluid login_page_wrapper">
                <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-4">
                        <div className="header_img_logo">
                            <img src={img} alt="Kinetic Logo"/>
                        </div>

                        <div className="login_form">
                            <h3 className="forgot_pw_rst">Password Reset</h3>
                            <p className="reset_pass_info">
                                Password reset instructions will be sent on the provided email address.
                            </p>
                            <input type="email" className="fgt_pw_email" id="email" placeholder="Email"/> <br />
                            
                            <input onClick={this.forgetPwHandler} type="submit" id="submit_box" value="reset"/>
                            <WindowAlert
                                show={this.state.isRequestSent}
                                messageType={this.state.messageType}
                                text={this.state.message}
                                onCofirm={this.handleAlert}
                            />
                        </div>

                        <div className="login_page_footer">
                            <h3><Link to="/login">I already have an account. Login</Link> </h3>
                            <ul className="footer_login_links">
                                <li><a href="">Terms of use</a></li>
                                <li><a href="">Privacy Policy</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-md-4"></div>
                </div>
            </div>
        )
    }
}

export default ForgotPassword


// WEBPACK FOOTER //
// ./src/app/forgot_password/ForgotPassword.js